import { ServiceProvidingLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { EmptyStatePlaceholder, Table } from '@dreryk/react-components';

import { serviceProvidingLocationTranslationKeys } from '../../../../translations';
import { HealthcarePracticeFormBean } from '../../common/healthcarePractice';

import {
   useServiceProvidingLocationsColumns,
   useServiceProvidingLocationsDataConfiguration,
} from './ServiceProvidingLocationTable.hooks';

type ServiceProvidingLocationTableProps = {
   readonly healthcarePractice: HealthcarePracticeFormBean;
};

export const ServiceProvidingLocationTable = (props: ServiceProvidingLocationTableProps): JSX.Element => {
   const dataConfiguration = useServiceProvidingLocationsDataConfiguration();
   const columns = useServiceProvidingLocationsColumns({
      healthcarePractice: props.healthcarePractice,
      refetchServiceProvidingLocations: dataConfiguration.refetch,
   });

   return (
      <Table<ServiceProvidingLocation>
         testId={'serviceProvidingLocation'}
         keyExtractor={'id'}
         columns={columns}
         dataConfiguration={dataConfiguration}
         placeholder={
            <EmptyStatePlaceholder
               heading={serviceProvidingLocationTranslationKeys.noServiceProvidingLocation}
               testId={'noServiceProvidingLocation'}
            />
         }
      />
   );
};
